import React          from 'react';
import ReactDom       from 'react-dom';
import Moment         from 'moment';

import Const          from 'fw_const';
import Utils          from 'utils';

import Card           from '@common/influencer/_card';

import Order          from '@common/influencer-search/order/_order';
import Actions        from '@common/influencer/parts/actions';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------


class List extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      tab : 'detault-view',
      tab_change : false,
    };
  }
  // -------------------------------------------------------
  
  changeTab(tab) {
    this.setState({ tab: tab, tab_change: true });
    
    setTimeout( function(){
      this.setState({ tab_change: false });
    }.bind(this), 150);
  }
  // -------------------------------------------------------
  
  refreshAction(tab) {
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    if( data == undefined ) data = {};
    
    if( data.items == undefined ) data.items = [];
    
    let base = this.props.base;
    
    let tabs = [
      { id: 'detault-view',    name: '一覧表示',       icon: 'view_module' },
      { id: 'post-module', name: '投稿付きの表示', icon: 'image_search' },
    ];
    
    return (
      <div className="influencer-list-contents">
        <h3 className="search-result">検索結果 ({Utils.viewInt(data.item_count)})</h3>
        <Order options={this.props.options} mode="account" search_ev={this.props.search_ev.bind(this)} />
        
        <div className="tab-action">
          <ul className="work-tabs">
            { tabs.map((d, key) => {
              let flg = (d.id == this.state.tab) ? 'on' : 'off';
              return (
                <OverlayTrigger key={key} placement="top" delayShow={50} overlay={<Tooltip>{d.name}</Tooltip>}>
                  <li className={flg} onClick={this.changeTab.bind(this, d.id)}>
                    <i className="material-icons">{d.icon}</i>
                  </li>
                </OverlayTrigger>
              );
            })}
          </ul>
        </div>
        
        { (this.state.tab_change == false) &&
          <div className="influencer-list">
            { data.items.map((d, key) => {
              if( this.state.tab == 'post-module' ){
                return <Card key={key} data={d} base={base} list={data.items} multi_action_flg={true} view_mode="post_module" />;
              } else {
                return <Card key={key} data={d} base={base} list={data.items} multi_action_flg={true} view_mode="" />;
              }
            })}
          </div>
        }
        
        { (data.items.length > 0 && data.items.length < data.item_count ) && <p className="button more" onClick={this.props.more_ev.bind(this)}>続きを見る</p> }
        
        { (base.multi_select != undefined && base.multi_select.length > 0) &&
          <div className="multi-select-action">
            <Actions base={base} data={{ projects_active: base.projects, multi_select_mode: base.multi_select_mode }} refresh_ev={this.refreshAction.bind(this)} />
          </div>
        }
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default List;